// Copyright (c) 2025 Audere, All Rights Reserved

export const LogoutReasons = {
  UserInitiated: "UserInitiated",
  ApiError: "ApiError",
  TokenExpired: "TokenExpired",
  UnauthorizedRole: "UnauthorizedRole",
} as const;

export type LogoutReason = keyof typeof LogoutReasons;

export type LogEventData = { group?: string } & (
  | {
      event: "userLogin";
      data: {
        success: boolean;
      };
    }
  | {
      event: "userLogout";
      data: {
        reason: LogoutReason;
      };
    }
);
